import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Hero from "@/components/sections/Hero";
import TrustSignals from "@/components/sections/TrustSignals";
import QuoteEstimator from "@/components/sections/QuoteEstimator";
import Services from "@/components/sections/Services";
import WhyDrone from "@/components/sections/WhyDrone";
import WhyDeepDive from "@/components/sections/WhyDeepDive";
import Process from "@/components/sections/Process";
import ServiceAreas from "@/components/sections/ServiceAreas";
import Crops from "@/components/sections/Crops";
import Gallery from "@/components/sections/Gallery";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";

export default function Home() {
  return (
    <div data-testid="home-page" className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <TrustSignals />
        <QuoteEstimator />
        <Services />
        <WhyDrone />
        <WhyDeepDive />
        <Process />
        <ServiceAreas />
        <Crops />
        <Gallery />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
